import storageManager from "modules/storage-manager";

const getToken = () => {
    const userData = storageManager.user.get();
    const token = userData?.token;

    return token;
}

export default getToken;